export default __webpack_public_path__ + "static/media/SEC3060.34I-43637_-26072_0.3de9a2e6.jpg";